import styles from './style.postcss';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Dialog, Button, TextArea, Icon, testClass, Form } from 'omni-common-ui';
import is from 'is_js';

class AddFreeTextDialog extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      categoryId: null,
      freeText: null,
      cicKey: null,
    };
    this._updateFreeText = this._updateFreeText.bind(this);
    this._onSaveClicked = this._onSaveClicked.bind(this);
    this._changeCategiry = this._changeCategiry.bind(this);
    this._changeLesson = this._changeLesson.bind(this);
  }

  _updateFreeText(e) {
    this.setState({ freeText: e.target.value });
  }

  _onSaveClicked() {
    const { freeText, categoryId } = this.state;
    this.props.onSave(this._getCICKey(), categoryId, freeText);
  }

  _getCICKey() {
    const { coveredInClassContent } = this.props;
    const { cicKey } = this.state;
    if (coveredInClassContent && coveredInClassContent.size === 1) {
      return coveredInClassContent.keySeq().first();
    }
    return cicKey;
  }

  _isFreeTextEmpty() {
    const { freeText, categoryId } = this.state;
    if (is.string(freeText) && categoryId) {
      return is.empty(this.state.freeText.trim());
    }
    return true;
  }

  _changeCategiry(val) {
    this.setState({ categoryId: val });
  }

  _changeLesson(val) {
    this.setState({ cicKey: val });
  }

  render() {
    const { isLoading, categoryOptions, coveredInClassContent } = this.props;

    const { categoryId, freeText, cicKey } = this.state;
    const categoryOptionList =
      categoryOptions &&
      categoryOptions.map((category) => ({
        label: category.cicCategoryName,
        value: category.cicCategoryId,
      }));

    const lessonOptions =
      coveredInClassContent &&
      coveredInClassContent
        .map((coveredInClass, key) => ({
          label: `Unit ${coveredInClass.unitOrderingSequence}, Lesson ${
            coveredInClass.lessonNumber
          }`,
          value: key,
        }))
        .toList()
        .toJS();
    return (
      <Dialog className={styles.AddFreeTextDialog} isLoading={isLoading} paddingless isOpen>
        <div className={styles.AddFreeTextDialog_title}>
          <span className={styles.AddFreeTextDialog_title_text}>Free Text Covered in Class</span>
        </div>
        <div className={styles.AddFreeTextDialog_content}>
          {lessonOptions && lessonOptions.length > 1 && (
            <div>
              <div className={styles.AddFreeTextDialog_subTitle}>
                <span className={styles.AddFreeTextDialog_title_text}>Lesson</span>
              </div>
              <Form>
                <Form.Select name="lesson"
                    options={lessonOptions}
                    value={cicKey}
                    setValue={this._changeLesson}
                    clearable={false}
                    searchable={false} />
              </Form>
            </div>
          )}
          <div className={styles.AddFreeTextDialog_subTitle}>
            <span className={styles.AddFreeTextDialog_title_text}>Category</span>
          </div>
          <Form>
            <Form.Select name="free-text"
                options={categoryOptionList}
                value={categoryId}
                setValue={this._changeCategiry}
                clearable={false}
                searchable={false} />
          </Form>
          <div className={styles.AddFreeTextDialog_subTitle}>
            <span className={styles.AddFreeTextDialog_title_text}>Free Text</span>
          </div>
          <TextArea value={freeText} onChange={this._updateFreeText} maxLength={1000} />
          <div className={styles.AddFreeTextDialog_content_info}>
            <Icon id="info" className={styles.AddFreeTextDialog_content_info_icon} />
            <span>This Free Text Covered in Class will be published to EF Parents.</span>
          </div>
          <Button.Container className={styles.AddFreeTextDialog_buttons}>
            <Button className={testClass('button-save')}
                type={Button.Type.primary}
                onClick={this._onSaveClicked}
                disabled={this._isFreeTextEmpty() || isLoading}>
              Save
            </Button>
            <Button className={testClass('button-cancel')}
                onClick={this.props.onCancel}
                disabled={isLoading}>
              Cancel
            </Button>
          </Button.Container>
        </div>
      </Dialog>
    );
  }
}

AddFreeTextDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  categoryOptions: PropTypes.object.isRequired,
  coveredInClassContent: PropTypes.object.isRequired,
};

export default AddFreeTextDialog;



// WEBPACK FOOTER //
// ./containers/Group/CoveredInClass/AddFreeTextDialog/index.jsx